export default __webpack_public_path__ + "static/media/stocks.4797177e.svg";